/**
 * Public Applications API client.
 */
import api from "../../Environment";

function unwrap(response) {
  return response && response.data ? response.data : response;
}

export async function submitApplication(payload) {
  const body = unwrap(await api.postMethod("applications/submit", payload));
  return body;
}

export async function fetchApplicationMeta() {
  try {
    const body = unwrap(await api.postMethod("applications/meta", {}));
    if (body && body.success && body.data) {
      return body.data;
    }
  } catch (e) {
    // ignore
  }
  return {
    types: {
      organization: "Organization",
      creator: "Creator",
      project: "Project",
    },
    statuses: {},
  };
}

export async function adminApplicationsMeta() {
  return unwrap(await api.postMethod("studio/applications/meta", {}));
}

export async function adminApplicationsList(filters = {}) {
  return unwrap(await api.postMethod("studio/applications", filters));
}

export async function adminApplicationShow(applicationId) {
  return unwrap(
    await api.postMethod("studio/applications/show", {
      application_id: applicationId,
    })
  );
}

export async function adminApplicationUpdate(payload) {
  return unwrap(await api.postMethod("studio/applications/update", payload));
}

export async function adminApplicationApprove(applicationId, reviewNotes) {
  return unwrap(
    await api.postMethod("studio/applications/approve", {
      application_id: applicationId,
      review_notes: reviewNotes || "",
    })
  );
}

export async function adminApplicationReject(applicationId, reviewNotes) {
  return unwrap(
    await api.postMethod("studio/applications/reject", {
      application_id: applicationId,
      review_notes: reviewNotes || "",
    })
  );
}

export async function adminApplicationRequestInfo(applicationId, reviewNotes) {
  return unwrap(
    await api.postMethod("studio/applications/request-information", {
      application_id: applicationId,
      review_notes: reviewNotes || "",
    })
  );
}
